<template>
  <div class="new-popupbox achievement-popupbox" :class="{ phoneMode }" @click="close()">
    <div class="hanlder-box">
      <svg class="icon-svg popup-close" @click="close()" v-if="!phoneMode">
        <use xlink:href="#icon-guanbi" />
      </svg>
    </div>
    <div class="achievement-box" :style="{ backgroundColor: theme_color }" @click.stop>
      <div class="achievement-top">
        <span>学习成就</span>
        <span>{{ myAchievementCount + '/' + achievementList.length }}</span>
      </div>
      <div class="achievement-list">
        <div class="achievement-item" v-for="item of achievementList" @click="showAchievement = item">
          <i class="achievement-cover" :class="{ notshow: !item.hadGot }"
            :style="{ backgroundImage: 'url(' + item.cover + ')' }"></i>
        </div>
      </div>
    </div>
    <showAchievement :showAchievement="showAchievement" type="show" @closeBox="showAchievement = null"
      v-if="showAchievement"></showAchievement>
  </div>
</template>

<script>
import { LoadingOutlined } from '@ant-design/icons-vue';
import showAchievement from "../show-achievement/show-achievement.vue";

export default {
  components: {
    LoadingOutlined, showAchievement
  },
  name: "achievement-box",
  props: {
    phoneMode: Boolean
  },
  data() {
    return {
      theme_color: '',
      classGuid: '',
      myAchievementCount: 0,

      showAchievement: null,
      achievementList: [],
    }
  },
  async mounted() {
    let { platform } = this.$store.state;
    this.theme_color = platform.pageConfig.theme_color;
    this.getAllAchievement();
  },
  methods: {
    //获取所有成就
    async getAllAchievement() {
      //找到已获得徽章
      let { levelInfo, allAchievementList = [] } = this.$store.state;
      let achievement = levelInfo ? levelInfo.achievement || [] : [];
      allAchievementList.forEach(aitem => {
        let amt = achievement.find(item => aitem._id == item.id);
        aitem.hadGot = amt ? true : false;
      })
      let ac1 = allAchievementList.filter(item => item.hadGot);
      let ac2 = allAchievementList.filter(item => !item.hadGot);
      this.achievementList = [...ac1, ...ac2];
      this.myAchievementCount = ac1.length;

      setTimeout(() => {
        $('.achievement-item').height($('.achievement-item').width())
      }, 100);
    },
    //关闭弹窗
    close() {
      this.$emit("closeBox", true);
    }
  },
}
</script>

<style scoped lang="scss">@import "./achievement-box.scss";</style>